// MEO landmark ads (Phase 1, Step 4-4, 2026-05-01) / T3-B PR 4-bis (2026-05-12):
//   占い文言プール用 API クライアント。
//   PR 4-bis (2026-05-12): listByTemplateMotif / createByTemplateMotif / remove を追加
//   (= roadmap v3 §7.2 案 β: 言語タブ + N 候補 + is_active トグル + 採用中ゼロ防止)。

import ApiService from './ApiService';

export default class OmikujiTextApi extends ApiService {
    // GET /system/omikuji-texts?fortune=&motif=&language=&status=&template_motif_id=&page=&limit=
    list(payload?: any) {
        return this.get('omikuji-texts', payload);
    }

    // PUT /system/omikuji-texts/:id
    update(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`omikuji-texts/${id}`, data);
    }

    // POST /system/omikuji-texts/generate (Claude 経由の一括生成)
    generate(payload: { fortune: number, motif: string, language: string, count: number }) {
        return this.post('omikuji-texts/generate', payload);
    }

    // PR 4-bis (2026-05-12): 占い文言プール CMS UI 用
    //
    // GET /system/template-motifs/:id/texts?language=
    listByTemplateMotif(payload: { template_motif_id: string | number, language?: string }) {
        const { template_motif_id, language } = payload;
        return this.get(`template-motifs/${template_motif_id}/texts`, language ? { language } : undefined);
    }

    // POST /system/template-motifs/:id/texts
    createByTemplateMotif(payload: { template_motif_id: string | number, data: any }) {
        const { template_motif_id, data } = payload;
        return this.post(`template-motifs/${template_motif_id}/texts`, data);
    }

    // DELETE /system/omikuji-texts/:id
    remove(id: string | number) {
        return this.delete(`omikuji-texts/${id}`);
    }
}
